export default class Partners {

  constructor (el) {
    this.el = el
    this.items = this.el.querySelectorAll('.js-partners-item')
    this.zIndex = 1
  }

  init () {
    this.initEvents()
  }

  initEvents () {
    if (!this.items.length) return

    this.items.forEach(el => {
      el.addEventListener('mouseenter', e => this.onMouseEnter(e))
      el.addEventListener('mouseleave', e => this.onMouseLeave(e))
    });
  }

  onMouseEnter(e) {
    e.stopPropagation()
    const target = e.currentTarget
    target.style.zIndex = this.zIndex + 1
    this.zIndex++
  }
  
  onMouseLeave(e) {
    e.stopPropagation()
    const target = e.currentTarget
    setTimeout(() => {
      target.style.zIndex = 1
    }, 300)
  }

}
